import { supabase } from '../../shared/infra/auth/SupabaseClient';

export const handleLogout = async () => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error('Error logging out:', error.message);
    }
  } catch (error) {
    console.error('Unexpected error during logout:', error);
  }
};

